export { VpIcon } from './VpIcon';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIcon/index.js